import keyBy from 'lodash.keyby';

export const keyByMiddleware = store => next => action => {
    const key = action.meta && action.meta.keyBy;

    if (!key || !action.payload || action.error) {
        return next(action);
    }

    const newAction = Object.assign({}, action, {
        payload: keyBy(action.payload, key)
    });
    return next(newAction);
};
